import axios from "@/app/Axios";
import routerProtected from "@/app/routerProtected";

class ComplementariosService {
/*   complementarios = {
    id: 0,
    carnet: 0,
    numero_licencia: 0,
    categoria_licencia: "",
    departamento_registro: "",
    telefono: 0,
    celular: 0,
    fecha_vencimiento: "",
  };

  constructor(complementarios) {
    this.complementarios = complementarios || { ...this.complementarios };
    routerProtected();
  }

  setFill(complementarios) {
    if (typeof this.complementarios !== 'object') {
      this.complementarios = {};
    }

    this.complementarios.id = complementarios.id || 0;
    this.complementarios.carnet = complementarios.carnet || 0;
    this.complementarios.numero_licencia = complementarios.numero_licencia || 0;
    this.complementarios.categoria_licencia = complementarios.categoria_licencia || 0;
    this.complementarios.departamento_registro = complementarios.departamento_registro || "";
    this.complementarios.telefono = complementarios.telefono || "";
    this.complementarios.celular = complementarios.celular || "";
    this.complementarios.fecha_vencimiento = complementarios.fecha_vencimiento || "";
  }

  getFill() {
    return this.complementarios;
  } */

  async index() {
    try {
      const response = await axios.get("/getcomplementarios");
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }

  async store(complementarios) {
    try {
      const response = await axios.post("/postcomplementarios", complementarios);
      return response.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }


  async destroy() {
    const id_registro = this.getFill().id;

    try {
      const response = await axios.delete(`/deletecomplementarios/${id_registro}`);
      return response.data;
    } catch (error) {
      console.error("Error al eliminar el registro:", error);
      return error.response.data;
    }
  }

  async update() {
    const id_registro = this.getFill().id;

    try {
      const response = await axios.put(`/putcomplementarios/${id_registro}`, this.getFill());
      return response.data;
    } catch (error) {
      console.error("Error al actualizar el registro:", error);
      return error.response.data;
    }
  }
}

export default ComplementariosService;
